import IconClose from './IconClose';

export default IconClose;
